import React, { Component } from "react";
import { Avatar, Button, Dropdown, Icon, Menu } from "antd";
import { urlPath } from "./Settings";
import { getUserName } from "../utils/security";

let langButtons = [];

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerFrameUrl: null,
      iconLoading: false,
      languageCode: this.props.languageCode,
      languages: null,
      loading: false,
      logo: "http://www.rossel.be/rossel/themes/img/logos/logo.png",
      matspec: null,
      specId: this.props.specId,
      strings: this.props.language,
      translations: null,
      orderno: this.props.orderno,
      matspecname: this.props.matspecname
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
    fetch(urlPath + "/api/noauth/loadconfig")
      .then(response => response.json())
      .then(data => {
        langButtons = [];
        //console.log('Loadconfig', data);
        this.setState({ languages: data.languages });
        for (let i = 0; i < data.languages.length; i++)
          langButtons.push(
            <Menu.Item
              data-language={data.languages[i].toUpperCase()}
              value={data.languages[i]}
              key={i}
            >
              {data.languages[i].toUpperCase()}
            </Menu.Item>
          );
      })
      .catch(e => console.error("Cannot load config, so no languages", e));
  }

  componentWillReceiveProps() {
    this.setState({
      translations: this.props.translations,
      languageCode: this.props.languageCode
    });
  }

  enterLoading = () => this.setState({ loading: true });

  enterIconLoading = () => this.setState({ iconLoading: true });

  handleMenuClick = e => {
    //console.log("Change language", e.item.props.value);
    localStorage.setItem("language", e.item.props.value);
    this.props.handleLangCode(e.item.props.value);
    setTimeout(() => this.setState({ strings: this.props.language }), 100);
  };

  render() {
    const renderButtons = [];
    const menu = <Menu onClick={this.handleMenuClick}>{langButtons}</Menu>;
    return (
      <header className="ix-header ix-app-header">
        {this.props.headerFrameUrl ? (
          <iframe
            id="header"
            title="header"
            className="ix-headerFrame"
            src={this.props.headerFrameUrl}
          />
        ) : null}
        <div className="ix-app-header-content">
          <div className="ix-header-orderno" >Campaign: <input value={this.state.orderno} /></div>
          <div className="ix-header-orderno" >Line item: <input value={this.state.matspecname} /></div>
          <div id="user" className="user">
            <Icon type="user" />
            <span>{getUserName()}</span>
          </div>
          <Avatar
            src={this.state.customFrames ? this.state.customFrames.url : "#"}
            className="ix-logo d-none"
            alt="logo"
          />
          <Menu
            onClick={this.handleClick}
            selectedKeys={[this.state.current]}
            mode="horizontal"
          >
            <Dropdown overlay={menu}>
              <Button className="uppercase" type="default">
                <Icon type="down" /> {this.state.languageCode}
              </Button>
            </Dropdown>
          </Menu>
          <Button onClick={this.props.clickHelp}>
            <span className="" data-translationkey="help">
              {this.state.translations ? this.state.translations.help : "Help"}
            </span>
            <Icon className="btn-help" type="question-circle" />
          </Button>
          <Button
            className="header--reload--button"
            style={{display: 'none'}}
            size="small"
            type="secondary"
            onClick={() => window.location.reload()}
          >
            <Icon type="reload" />
          </Button>
          {renderButtons}
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js